export const ApiMeta = (json: IApiMeta): IApiMetaModel => {
	const { current_page, last_page, per_page, ...rest } = json
	return {
		...rest,
		currentPage: current_page,
		lastPage: last_page,
		perPage: per_page,
	}
}

export const ApiResponse = <T>(json: IApiCommon<T>): IApiCommonModel<T> => {
	const { meta, ...rest } = json
	return {
		...rest,
		meta: meta ? ApiMeta(meta) : undefined,
	}
}
